import Logo from "@/src/sb/components/Logo"
import { SimpleLink } from "@/src/sb/components/SimpleLink"
import Spinner from "@/src/sb/components/icon/Spinner"
import { pages } from "@/src/sb/constants/copy"

type FallbackProps = {
  logo?: boolean
  children?: string
}
export const Fallback = ({ children, logo = true }: FallbackProps) => (
  <>
    {logo ? (
      <SimpleLink href={pages.landingPage} color="black">
        <Logo type="redLarge" />
      </SimpleLink>
    ) : null}
    <div className="flex items-center justify-center text-white h-screen">
      <Spinner>{children}</Spinner>
    </div>
  </>
)
